import { render, staticRenderFns } from "./CustomerDetailVehicles.vue?vue&type=template&id=37785466"
import script from "./CustomerDetailVehicles.vue?vue&type=script&lang=js"
export * from "./CustomerDetailVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports